/*###########################################################################
// Slider detailed
//#########################################################################*/

import Swiper from "swiper"
import { debounce } from "@js/utilities/_throttleDebounce"

const sliderDetailed = {
  config: {
    sliderDetailed: '.sliderDetailed'
  },

  elements: {},

  init() {
    const self = this

    self.elements.sliderDetailed = document.querySelectorAll(self.config.sliderDetailed)

    if (self.elements.sliderDetailed !== null) {
      for (let i = 0; i < self.elements.sliderDetailed.length; i++) {
        const sliderDetailed = self.elements.sliderDetailed[i]

        self.handleSliderDetailed(sliderDetailed)
      }
    }
  },

  initSlider(slider) {
		const controls = slider.parentNode.querySelector('.slider__controls')
    const prevBtn = slider.parentNode.querySelector('.slider__control--prev')
    const nextBtn = slider.parentNode.querySelector('.slider__control--next')

    const swiper = new Swiper(slider, {
      slidesPerView: 1.2,
      spaceBetween: 32,
      loop: false,
      autoHeight: true,
      breakpoints: {
        360: {
          slidesPerView: 1.25,
          spaceBetween: 32,
        },
        414: {
          slidesPerView: 1.25,
          spaceBetween: 32,
        },
        520: {
          slidesPerView: 1.5,
          spaceBetween: 32,
        },
        700: {
          slidesPerView: 1.75,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 2.75,
          spaceBetween: 32
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      },

			on: {
				afterInit: function (swiper) {
					const currentSlidesPerView = swiper.slidesPerViewDynamic()

					if (currentSlidesPerView < swiper.slides.length) {
						controls.classList.remove('hidden')
					} else {
						controls.classList.add('hidden')
					}
				},
			},
    })

    if (prevBtn !== null && nextBtn !== null && swiper && !swiper.destroyed) {
      if (swiper.isBeginning) {
        prevBtn.classList.add('is-disabled')
      }

      swiper.on('slideChange', function() {
        if (swiper.isBeginning) {
          prevBtn.classList.add('is-disabled')
        }

        if (swiper.isEnd) {
          nextBtn.classList.add('is-disabled')
        }
      })

      swiper.on('fromEdge', function() {
        prevBtn.classList.remove('is-disabled')
        nextBtn.classList.remove('is-disabled')
      })

      swiper.on('reachBeginning', function () {
        if (swiper.isBeginning) {
          prevBtn.classList.add('is-disabled')
        }
      })

      swiper.on('reachEnd', function () {
        if (swiper.isEnd) {
          nextBtn.classList.add('is-disabled')
        }
      })

      prevBtn.addEventListener('click', function (e) {
        swiper.slidePrev(500)
      })

      nextBtn.addEventListener('click', function (e) {
        swiper.slideNext(500)
      })

      // Workaround for weird bug of miscalculations
      //
      swiper.update()
    }

    return swiper
  },

  handleSliderDetailed(slider) {
    const self = this

    let swiper = self.initSlider(slider)
    let width = window.innerWidth

    window.addEventListener("resize", debounce(function() {
      if (window.innerWidth !== width) {
        swiper.destroy()

        setTimeout(function() {
          swiper = self.initSlider(slider)
        }, 500)

        width = window.innerWidth
      }
    }, 500))
  }
}

window.addEventListener('load', function () {
  sliderDetailed.init()
})
